import React from 'react';

// Home Page Section 2 / this is section list sample events
export const HomePageS2  = (props) =>  ( 

    <div className="homepage-s2">
        <h2 className="event-list-para-title">Quickly And Easily Organize</h2>
        <hr className="hr-medium" />
        <div className="event-list">
            <ul className="event-list__group">
                <li>Indoor/Outdoor Parties</li>
                
                <li>Family Reunion</li>
            </ul>
            <ul className="event-list__group">
                <li>Church Functions</li>
                
                <li>Tailgate Parties</li>
            </ul>
            <ul className="event-list__group">
                <li>School Functions</li>
                
                <li>Weekend Getaways</li>
            </ul>
            <ul className="event-list__group">
                <li>Voluteer Efforts</li>
                
                <li>Camping Trips</li>
            </ul>
        </div>
        <h3 className="event-list-para">...or any event or function where people can "Pitch In"</h3>
    </div>
);
   




// WEBPACK FOOTER //
// ./src/components/HomePageS2.js